import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';

/**
 * Displays spinner icon before button text when directive
 * value is set to true
 */
@Directive({
  selector: '[appButtonSpinner]'
})
export class ButtonSpinnerDirective implements OnChanges {
  @Input('appButtonSpinner') active: boolean;

  private _spinnerEl = this._buildSpinner();
  /**
   *
   */
  constructor(
    private elRef: ElementRef,
    private renderer: Renderer2
  ) {
  }

  ngOnChanges(changes: SimpleChanges) {
    const change = changes['active'];
    if (change) {
      try {
        this.toggleSpiner();
      } catch (e) {
        console.warn('There was an problem toggling the spinner', e);
      }
    }
  }

  toggleSpiner() {
    if (this.active) {
      this.renderer.insertBefore(this.elRef.nativeElement, this._spinnerEl, this.elRef.nativeElement.childNodes[0]);
    } else {
      this.renderer.removeChild(this.elRef.nativeElement, this._spinnerEl);
    }
  }

  private _buildSpinner() {
    const el = this.renderer.createElement('i');
    this.renderer.addClass(el, 'fal');
    this.renderer.addClass(el, 'fa-spinner-third');
    this.renderer.addClass(el, 'fa-spin');
    this.renderer.addClass(el, 'loader__icon');
    this.renderer.addClass(el, 'loader__icon--btn');
    this.renderer.setAttribute(el, 'style', 'margin-right: .5rem;');
    return el;
  }

}
